export default "__VITE_PUBLIC_ASSET__ccc03621__"